// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B4XwPEftS0QL5trpqVV1{white-space:nowrap;gap:4px;padding:6px 8px;display:flex}.c8n1it8X08rvE4XjlvON{color:var(--light-blue-50);cursor:pointer}.c8n1it8X08rvE4XjlvON:hover{color:var(--content-brand-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `B4XwPEftS0QL5trpqVV1`,
	"link": `c8n1it8X08rvE4XjlvON`
};
export default ___CSS_LOADER_EXPORT___;
